// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import '@popperjs/core'
import * as bootstrap from "bootstrap"

document.addEventListener("turbo:load", function() {
})
